import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";

function Footer() {
    return (
        <div className="footer-container">
            <section class="social-media">
                <div class="social-media-wrap">
                    <div class="footer-logo">
                        <Link to="/" className="social-logo">
                            <img src="img/wings.svg" alt="" />
                        </Link>
                    </div>
                    <small class="website-rights">Wings © 2020</small>
                    <div>
                        <div class="social-icons">
                            <a
                                class="social-icon-link facebook"
                                href="https://www.facebook.com/allegro.wings/"
                            >
                                <i class="fab fa-facebook-f" />
                            </a>
                            <a
                                class="social-icon-link instagram"
                                href="https://www.instagram.com/allegro.wings/"
                            >
                                <i class="fab fa-instagram" />
                            </a>
                        </div>
                        <a
                            className="social-link small"
                            href="mailto:allegro.wings@gmail.com"
                        >
                            <i class="fa fa-envelope-o"></i>
                            {""}
                            allegro.wings@gmail.com
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Footer;
